import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Calendar, ArrowRight } from "lucide-react";
import { CONSULTATION_URL } from "@/data/constants";

/**
 * Sticky "Book Consultation" pill anchored to the bottom of mobile only.
 * - Hidden on ≥ md breakpoint (desktop already surfaces the CTA in the header)
 * - Hidden inside /admin and /portal (internal tools shouldn't nudge to book)
 * - Fades in after 200 px of scroll so it doesn't cover above-the-fold hero content
 */
const StickyMobileCTA = () => {
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  const hideOnRoute = location.pathname.startsWith("/admin") || location.pathname.startsWith("/portal") || location.pathname.startsWith("/login") || location.pathname.startsWith("/register");

  useEffect(() => {
    if (hideOnRoute) return;
    const onScroll = () => setVisible(window.scrollY > 200);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [hideOnRoute]);

  if (hideOnRoute) return null;

  return (
    <a
      href={CONSULTATION_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="sticky-mobile-cta"
      aria-label="Book a Consultation"
      className={`md:hidden fixed z-40 left-4 right-4 bottom-4 flex items-center justify-center gap-2 px-5 py-3.5 rounded-full font-semibold text-[15px] tracking-tight text-[var(--ft-black)] shadow-[0_10px_28px_rgba(200,162,74,0.32)] border border-[var(--ft-gold)]/60 transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
      style={{
        background: "linear-gradient(180deg, #d9b96b 0%, var(--ft-gold) 55%, #b0862e 100%)",
        backdropFilter: "blur(6px)",
      }}
    >
      <Calendar size={16} strokeWidth={2} />
      <span>Book a Consultation</span>
      <ArrowRight size={15} strokeWidth={2.25} />
    </a>
  );
};

export default StickyMobileCTA;
